import { Link, useLocation } from "react-router-dom";
import { Home, BookOpen, Sparkles, NotebookPen, User } from "lucide-react";

const items = [
  { label: "Chamber", to: "/chamber", icon: Home, match: (p: string, s: string) => p === "/chamber" },
  { label: "Journal", to: "/journal", icon: BookOpen, match: (p: string) => p === "/journal" },
  { label: "Reflections", to: "/reflections", icon: NotebookPen, match: (p: string) => p === "/reflections" },
  {
    label: "You",
    to: "/dashboard?tab=settings",
    icon: User,
    match: (p: string, s: string) => p === "/dashboard" && s.includes("tab=settings"),
  },
];

export default function BottomTabBar() {
  const location = useLocation();
  const p = location.pathname;
  const s = location.search;

  const left = items.slice(0, 2);
  const right = items.slice(2);

  const cell = (item: (typeof items)[number]) => {
    const active = item.match(p, s);
    const Icon = item.icon;
    return (
      <Link
        key={item.label}
        to={item.to}
        className={`flex flex-1 flex-col items-center justify-center gap-1 py-2 min-h-[48px] transition-colors ${
          active ? "text-accent" : "text-muted-foreground"
        }`}
      >
        <Icon size={20} strokeWidth={active ? 2.2 : 1.7} />
        <span className="text-[9px] font-medium tracking-wide">{item.label}</span>
      </Link>
    );
  };

  const councilActive = p === "/coach";

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-background/95 backdrop-blur-xl">
      <div className="mx-auto flex max-w-xl items-end px-3 pb-[env(safe-area-inset-bottom)]">
        {left.map(cell)}

        <div className="flex flex-1 flex-col items-center justify-end">
          <Link
            to="/coach"
            aria-label="Council"
            className={`-mt-6 flex h-14 w-14 items-center justify-center rounded-full bg-accent text-accent-foreground shadow-lg transition-transform hover:scale-105 ${
              councilActive ? "ring-2 ring-accent ring-offset-2 ring-offset-background" : ""
            }`}
          >
            <Sparkles size={22} strokeWidth={2} />
          </Link>
          <span
            className={`pb-2 pt-1 text-[9px] font-medium tracking-wide ${
              councilActive ? "text-accent" : "text-muted-foreground"
            }`}
          >
            Council
          </span>
        </div>

        {right.map(cell)}
      </div>
    </nav>
  );
}
